declare global {
  interface String {
    equalsIgnoreDash(other: string, ignoreCase?: boolean): boolean;
    stripDash(replaceWith?: string): string;
    toUrlFriendly(): string;
    fromUrlFriendly(): string;
    toTitleCase(): string;
    trimTrailingForwardSlash(): string;
    trimForwardSlashes(): string;
    stripPeriod(): string;
    condenseDashes(): string;
    removeSpecialCharacters(): string;
    sanitizeHyphens(): string;
  }
}

String.prototype.equalsIgnoreDash = function (this: string, other: string, ignoreCase = true) {
  if (this === other) {
    return true;
  }
  let thisString = this.stripDash();
  let otherString = other.stripDash();
  if (ignoreCase) {
    thisString = thisString.toLowerCase();
    otherString = otherString.toLowerCase();
  }
  return thisString === otherString;
};

String.prototype.stripDash = function (this: string, replaceWith = '') {
  return this.replace(/-/g, replaceWith);
};

String.prototype.toUrlFriendly = function (this: string) {
  return this.toLowerCase().replace(/ /g, '-');
};

String.prototype.fromUrlFriendly = function (this: string) {
  return this.toLowerCase().replace(/-/g, ' ').replace(/\s{3}/g, ' - ');
};

String.prototype.toTitleCase = function (this: string) {
  return this.split(' ')
    .map((word) => `${word.charAt(0).toUpperCase()}${word.substring(1)}`)
    .join(' ');
};

String.prototype.trimTrailingForwardSlash = function (this: string) {
  return this.replace(/\/+$/g, '');
};

String.prototype.trimForwardSlashes = function (this: string) {
  return this.replace(/^\/+|\/+$/g, '');
};

String.prototype.stripPeriod = function (this: string) {
  return this.replace(/\./g, '');
};

String.prototype.condenseDashes = function (this: string) {
  return this.replace(/-{2,}/g, '-');
};

String.prototype.removeSpecialCharacters = function (this: string) {
  return this.replace(/[^a-zA-Z0-9-]/g, '');
};

String.prototype.sanitizeHyphens = function (this: string) {
  return this.replace(/--+/g, '-');
};

export {};
